import {
  ProteinFormulation,
  TreeNodeExtenededResponseMessageDTO,
} from 'business/models/Models';
import ProteinFormulationService from 'business/services/ProteinFormulationService';
import { TreeNodeDetail } from 'components/explorer/constants';
import { useDeleteNodesHandler } from 'components/explorer/hooks';

import ProteinVariant from 'components/main/ProteinFormulation/ProteinVariant/Index';
import ProteinVariantCard from 'components/main/ProteinFormulation/ProteinVariant/ProteinVariantCard';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { FmlxButton, FmlxIcon } from 'fmlx-common-ui';
import React, { useEffect, useState } from 'react';
import { openNode } from 'utils/Global';

interface ProteinVariantListInfoPanelProps {
  treeNodeId: number;
  onRefreshTreeNodeAfterProteinVariantChange(nodeId: number, isExist: boolean): any;
  showProteinVariantModal: boolean;
  setShowProteinVariantModal(show: boolean): any;
}

const ProteinVariantListInfoPanel = (props: ProteinVariantListInfoPanelProps) => {
  const {
    treeNodeId,
    onRefreshTreeNodeAfterProteinVariantChange,
    showProteinVariantModal,
    setShowProteinVariantModal,
  } = props;
  const [proteinFormulationVariants, setProteinFormulationVariants] = useState<
    ProteinFormulation[]
  >([]);
  const deleteNodesHandler = useDeleteNodesHandler();
  const [openedWindows, setOpenedWindows] = useState([]);
  const [refreshVariantList, setRefreshVariantList] = useState<boolean>(false);

  useEffect(() => {
    const pfService = new ProteinFormulationService();
    const fetchPfVariantsData = async () => {
      try {
        const data = await pfService.getProteinFormulationVariants(treeNodeId);
        if (
          (proteinFormulationVariants.length == 0 && data.length > 0) ||
          (proteinFormulationVariants.length > 0 && data.length == 0)
        ) {
          const isVariantExists = data.length == 0 ? false : true;
          onRefreshTreeNodeAfterProteinVariantChange(treeNodeId, isVariantExists);
        }
        setProteinFormulationVariants(data);
      } catch (error) {
        console.error('Error fetching pf data:', error);
      }
    };
    fetchPfVariantsData();
  }, [treeNodeId, refreshVariantList]);

  const handleDeletePfVariant = async (treeNodeId, treeNodeName, type) => {
    const treeNodeDTO: TreeNodeDetail[] = [];
    const variantTreeNode: TreeNodeDetail = {
      treeNodeId: treeNodeId,
      name: treeNodeName,
      type: type as ETreeNodeTypes,
      entityId: undefined,
    };
    treeNodeDTO.push(variantTreeNode);

    await deleteNodesHandler(treeNodeDTO, nodesDeletePostProcessor);
  };

  const nodesDeletePostProcessor = (
    deletedNodeIds: number[],
    undeletedNodes: TreeNodeExtenededResponseMessageDTO[],
  ) => {
    setRefreshVariantList(!refreshVariantList);
  };

  const proteinVariantDoubleClickHandler = (variantNodeId) => {
    const link = `/protein/${variantNodeId}`;
    openNode(link, link, variantNodeId, openedWindows, setOpenedWindows);
  };

  return (
    <>
      <div id="proteinvariantlistinfopanel-panel-wrapper" className="h-[65.5%] flex flex-col">
        <div id="proteinvariantlistinfopanel-panel-header-section" className="flex flex-col h-[19.7%] mb-[2%]">
          <div id="proteinvariantlistinfopanel-panel-header-title" className="h-[58%] w-[100%] pl-[2%] content-center font-bold text-[1.077rem]">
            Protein Variant
          </div>
          <div id="proteinvariantlistinfopanel-panel-create-button-container" className="w-[100%] h-[42%] flex flex-row items-center justify-center">
            <FmlxButton
              id="proteinvariantlistinfopanel-panel-button-create"
              label="CREATE VARIANT"
              withIcon={FmlxButton.WithIcon.START}
              icon={<FmlxIcon id='proteinvariantlistinfopanel-createvariant-circle-icon' name="AddCircle" />}
              type={FmlxButton.Type.POSITIVE}
              onClick={() => setShowProteinVariantModal(true)}
              withTooltip
              tooltipDescription="Create Protein Variant"
              tooltipPlacement={FmlxButton.TooltipPlacement.BOTTOM}
            />
          </div>
        </div>
        {proteinFormulationVariants.length === 0 && (
          <div id="proteinvariantlistinfopanel-panel-empty-message" className="w-[100%] h-[8%] text-center content-center text-[#5D5D5D] text-[1.077rem]">
            Add new variant to create protein variant
          </div>
        )}

        {proteinFormulationVariants.length > 0 && (
          <div id="proteinvariantlistinfopanel-panel-variant-list" className="w-[100%] h-[78%] overflow-auto">
            {proteinFormulationVariants.map((pFVariant, index) => (
              <ProteinVariantCard
                id={`proteinvariantlistinfopanel-panel-variantcard-${index}`}
                key={`proteinVariantCard${index}`}
                pFVariant={pFVariant}
                proteinVariantDoubleClickHandler={proteinVariantDoubleClickHandler}
                handleDeletePfVariant={handleDeletePfVariant}
              />
            ))}
          </div>
        )}
      </div>
      <ProteinVariant
        id="proteinvariantlistinfopanel-panel-modal"
        showModal={showProteinVariantModal}
        setShowModal={setShowProteinVariantModal}
        parentProteinTreeNodeId={treeNodeId}
        setRefreshVariantList={setRefreshVariantList}
        refreshVariantList={refreshVariantList}
        proteinFormulationVariants={proteinFormulationVariants}
      />
    </>
  );
};

export default ProteinVariantListInfoPanel;
